import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';

/** Включает фастскролл в галерее */
export const enableGalleryFastscroll: boolean = isFeature('enable-gallery-fastscroll');

/** Переключает для галереи ручку feed с v2 на v4 */
export const galleryFeedV2ToV4: boolean = isFeature('gallery-feed-v2-to-v4');

/** Задержка запроса данных якоря при попадании его во вьюпорт */
export const anchorRequestDelay: number = getFeature('anchor-request-delay') || 100;

/** Отступы для запроса данных якоря при попадании его во вьюпорт */
export const anchorRequestMargin: string = getFeature('anchor-request-delay') || '300px';
